import React, { Component } from "react";
import CartContext from "./CartContext";
import { SideMenu } from "./SideMenu";
import { BiRefresh } from "react-icons/bi";
import { BsFillPencilFill, BsFillPrinterFill } from "react-icons/bs";
import { MessageBox } from "./MessageBox";
import { LoadSpinner } from "./LoadSpinner";
import ReactDOM from "react-dom";
import Select from "react-select";
import Fuse from "fuse.js";
import Swal from "sweetalert2";
import { FaRegFilePdf } from "react-icons/fa6";

import {
  Accordion,
  Spinner,
  Badge,
  ListGroup,
  OverlayTrigger,
  Tooltip,
  Stack,
  FormControl,
  InputGroup,
  Button,
  ButtonToolbar,
  Form,
  Row,
  Col,
  Modal,
  Nav,
  Table,
  Navbar,
  Tabs,
  ButtonGroup,
  Tab,
  FloatingLabel,
} from "react-bootstrap";
import { TbTower } from "react-icons/tb";

export class RawMaterialIndent extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      rawmaterialpurchaserequests: [],
      rawmaterialcategory: [],
      rawmaterialwarehouse: [],
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      reload: true,
      rawmaterialsuppliers: [],
      prods: [],
      loaded: false,
      ShowCreatedTabRefresh: true,
      ShowSentTabRefresh: false,
      ShowReceivedTabRefresh: false,
      ShowPartiallyReceivedTabRefresh: false,
      ShowCancelledTabRefresh: false,
      ShowRejectedTabRefresh: false,
      ShowCompletedTabRefresh: false,
      status: 0,
    };
  }
  GetRawMaterialSuppliers = () => {
    fetch(
      process.env.REACT_APP_API +
        "Supplier/GetSuppliers/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ rawmaterialsuppliers: data }, () => {
            this.setState({ reload: false }, () => {
              this.setState({ reload: true });
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };
  GetRawMaterialCategories = () => {
    fetch(
      process.env.REACT_APP_API +
        "Rawmaterials/GetRawMaterialCategories/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ rawmaterialcategory: data }, () => {
            this.setState({ reload: false }, () => {
              this.setState({ reload: true });
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };
  GetRawMaterialWarehouses = () => {
    fetch(
      process.env.REACT_APP_API +
        "Warehouse/GetRawMaterialWarehouses/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ rawmaterialwarehouse: data }, () => {
            this.setState({ reload: false }, () => {
              this.setState({ reload: true });
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };
  GetRawMaterialsInventories = () => {
    fetch(
      process.env.REACT_APP_API +
        "Rawmaterials/GetRawMaterialsInventories/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ prods: data }, () => {
            this.setState({ reload: false }, () => {
              this.setState({ reload: true });
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  GetRawMaterialPurchaseRequest = () => {
    fetch(
      process.env.REACT_APP_API +
        "Rawmaterials/GetRawMaterialPurchaseRequest/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ rawmaterialpurchaserequests: data }, () => {
            this.setState({ reload: false }, () => {
              this.setState({ reload: true });
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  OnSaved = () => {
    this.OnRefreshButtonClick();
  };
  OnDeleted = () => {
    this.OnRefreshButtonClick();
  };

  OnRefreshButtonClick = () => {
    this.setState({ rawmaterialpurchaserequests: [] }, () => {
      this.GetRawMaterialPurchaseRequest();
    });
  };
  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };

  OnUpdated = (indexno) => {
    this.OnRefreshButtonClick();
  };

  addModalClose = () => {
    this.setState({ addModalShow: false }, () => {});
    this.OnRefreshButtonClick();
  };
  ShowSelectedTab = (k) => {
    this.setState({ ShowCreatedTabRefresh: false });
    this.setState({ ShowSentTabRefresh: false });
    this.setState({ ShowReceivedTabRefresh: false });
    this.setState({ ShowPartiallyReceivedTabRefresh: false });
    this.setState({ ShowCancelledTabRefresh: false });
    this.setState({ ShowRejectedTabRefresh: false });
    this.setState({ ShowCompletedTabRefresh: false });

    if (k == "New") this.setState({ ShowCreatedTabRefresh: true });
    if (k == "Sent") this.setState({ ShowSentTabRefresh: true });
    if (k == "Received") this.setState({ ShowReceivedTabRefresh: true });
    if (k == "PartiallyReceived")
      this.setState({ ShowPartiallyReceivedTabRefresh: true });
    if (k == "Cancelled") this.setState({ ShowCancelledTabRefresh: true });
    if (k == "Rejected") this.setState({ ShowRejectedTabRefresh: true });
    if (k == "Completed") this.setState({ ShowCompletedTabRefresh: true });
  };

  componentDidMount = () => {
    if (this.state.loaded == false) {
      this.GetRawMaterialPurchaseRequest();
      this.GetRawMaterialsInventories();
      this.GetRawMaterialCategories();
      this.GetRawMaterialSuppliers();
      this.GetRawMaterialWarehouses();
      this.state.loaded = true;
    }
    window.scrollTo(0, 0);

    document.addEventListener("keydown", (event) => {
      if (event.key == "F8") {
        this.setState({ addModalShow: true });
      } else if (event.key == "F9") {
        this.OnRefreshButtonClick();
      }
    });
  };

  render() {
    return (
      <>
        <div className="Container-fluid p-0 ">
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          <Navbar className="shadow position-sticky fixed-top py-3 text-black ">
            <h4> RawMaterial Purchase Order INDENT &nbsp;</h4>
            <Navbar.Collapse className="justify-content-end mx-0 ">
              <Nav>
                <ButtonToolbar className="text-end align-middle">
                  <Button
                    size="sm"
                    className="mainthemecolor"
                    onClick={() => this.setState({ addModalShow: true })}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-plus"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                    </svg>
                    &nbsp;Add (F8)
                  </Button>
                  &nbsp;
                  <Button
                    className="mainthemecolor"
                    size="sm"
                    onClick={() => this.OnRefreshButtonClick()}
                  >
                    <BiRefresh size="16"></BiRefresh>
                    &nbsp;Refresh (F9)
                  </Button>
                  &nbsp;
                  {this.state.addModalShow === true ? (
                    <RawMaterialPurchaseRequestAddOrEditModal
                      show={this.state.addModalShow}
                      Type="Add"
                      status={this.state.status}
                      onHide={this.addModalClose}
                      rawmaterialsuppliers={this.state.rawmaterialsuppliers}
                      prods={this.state.prods}
                      rawmaterialcategory={this.state.rawmaterialcategory}
                      rawmaterialwarehouse={this.state.rawmaterialwarehouse}
                    />
                  ) : null}
                </ButtonToolbar>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
          <div className="purposestyle p-2 ">
            {" "}
            <b>Purpose:</b> Use this module to plan Rawmaterial Purchases. Once
            a Purchase Order created, It can share it to Supplier as a PDF file
            or a Printout.
          </div>
          <Tabs
            id="controlled-tab-example"
            activeKey={this.state.key}
            onSelect={(k) => {
              this.setState({ key: k });
              this.ShowSelectedTab(k);
            }}
            className="mb-3 bg-light fw-bold"
            fill
            style={{ fontSize: "16px", color: "yellow" }}
          >
            <Tab
              eventKey="New"
              title={
                "1.New Indent (" +
                this.state.rawmaterialpurchaserequests.filter(
                  (f) => f.status == 0
                ).length +
                ")"
              }
              style={{ label: "abc" }}
            >
              {this.state.ShowCreatedTabRefresh == true ? (
                <>
                  <RawMaterialPurchaseRequestTable
                    status="0"
                    rawmaterialpurchaserequests={
                      this.state.rawmaterialpurchaserequests
                    }
                    rawmaterialcategory={this.state.rawmaterialcategory}
                    rawmaterialsuppliers={this.state.rawmaterialsuppliers}
                    rawmaterialwarehouse={this.state.rawmaterialwarehouse}
                    prods={this.state.prods}
                    OnDeleted={this.OnDeleted}
                    onHide={this.addModalClose}
                  ></RawMaterialPurchaseRequestTable>
                </>
              ) : (
                <></>
              )}
            </Tab>
            <Tab
              eventKey="Sent"
              title={
                "2.Sent to Supplier (" +
                this.state.rawmaterialpurchaserequests.filter(
                  (f) => f.status == 1
                ).length +
                ")"
              }
              style={{ label: "abc" }}
            >
              {this.state.ShowSentTabRefresh == true ? (
                <>
                  <RawMaterialPurchaseRequestTable
                    status="1"
                    rawmaterialpurchaserequests={
                      this.state.rawmaterialpurchaserequests
                    }
                    rawmaterialcategory={this.state.rawmaterialcategory}
                    rawmaterialsuppliers={this.state.rawmaterialsuppliers}
                    rawmaterialwarehouse={this.state.rawmaterialwarehouse}
                    prods={this.state.prods}
                    OnDeleted={this.OnDeleted}
                    onHide={this.addModalClose}
                  ></RawMaterialPurchaseRequestTable>
                </>
              ) : (
                <></>
              )}
            </Tab>
            <Tab
              eventKey="Received"
              title={
                "3.Received (" +
                this.state.rawmaterialpurchaserequests.filter(
                  (f) => f.status == 2
                ).length +
                ")"
              }
              style={{ label: "abc" }}
            >
              {this.state.ShowReceivedTabRefresh == true ? (
                <>
                  <RawMaterialPurchaseRequestTable
                    status="2"
                    rawmaterialpurchaserequests={
                      this.state.rawmaterialpurchaserequests
                    }
                    rawmaterialcategory={this.state.rawmaterialcategory}
                    rawmaterialsuppliers={this.state.rawmaterialsuppliers}
                    rawmaterialwarehouse={this.state.rawmaterialwarehouse}
                    prods={this.state.prods}
                    OnDeleted={this.OnDeleted}
                    onHide={this.addModalClose}
                  ></RawMaterialPurchaseRequestTable>
                </>
              ) : (
                <></>
              )}
            </Tab>
            <Tab
              eventKey="PartiallyReceived"
              title={
                "4.Partially Received (" +
                this.state.rawmaterialpurchaserequests.filter(
                  (f) => f.status == 3
                ).length +
                ")"
              }
              style={{ label: "abc" }}
            >
              {this.state.ShowPartiallyReceivedTabRefresh == true ? (
                <>
                  <RawMaterialPurchaseRequestTable
                    status="3"
                    rawmaterialpurchaserequests={
                      this.state.rawmaterialpurchaserequests
                    }
                    rawmaterialcategory={this.state.rawmaterialcategory}
                    rawmaterialsuppliers={this.state.rawmaterialsuppliers}
                    rawmaterialwarehouse={this.state.rawmaterialwarehouse}
                    prods={this.state.prods}
                    OnDeleted={this.OnDeleted}
                    onHide={this.addModalClose}
                  ></RawMaterialPurchaseRequestTable>
                </>
              ) : (
                <></>
              )}
            </Tab>
            <Tab
              eventKey="Cancelled"
              title={
                "5.Cancelled (" +
                this.state.rawmaterialpurchaserequests.filter(
                  (f) => f.status == 4
                ).length +
                ")"
              }
              style={{ label: "abc" }}
            >
              {this.state.ShowCancelledTabRefresh == true ? (
                <>
                  <RawMaterialPurchaseRequestTable
                    status="4"
                    rawmaterialpurchaserequests={
                      this.state.rawmaterialpurchaserequests
                    }
                    rawmaterialcategory={this.state.rawmaterialcategory}
                    rawmaterialsuppliers={this.state.rawmaterialsuppliers}
                    rawmaterialwarehouse={this.state.rawmaterialwarehouse}
                    prods={this.state.prods}
                    OnDeleted={this.OnDeleted}
                    onHide={this.addModalClose}
                  ></RawMaterialPurchaseRequestTable>
                </>
              ) : (
                <></>
              )}
            </Tab>
            <Tab
              eventKey="Rejected"
              title={
                "6.Rejected (" +
                this.state.rawmaterialpurchaserequests.filter(
                  (f) => f.status == 5
                ).length +
                ")"
              }
              style={{ label: "abc" }}
            >
              {this.state.ShowRejectedTabRefresh == true ? (
                <>
                  <RawMaterialPurchaseRequestTable
                    status="5"
                    rawmaterialpurchaserequests={
                      this.state.rawmaterialpurchaserequests
                    }
                    rawmaterialcategory={this.state.rawmaterialcategory}
                    rawmaterialsuppliers={this.state.rawmaterialsuppliers}
                    rawmaterialwarehouse={this.state.rawmaterialwarehouse}
                    prods={this.state.prods}
                    OnDeleted={this.OnDeleted}
                    onHide={this.addModalClose}
                  ></RawMaterialPurchaseRequestTable>
                </>
              ) : (
                <></>
              )}
            </Tab>
            <Tab
              eventKey="Completed"
              title={
                "7.Completed (" +
                this.state.rawmaterialpurchaserequests.filter(
                  (f) => f.status == 6
                ).length +
                ")"
              }
              style={{ label: "abc" }}
            >
              {this.state.ShowCompletedTabRefresh == true ? (
                <>
                  <RawMaterialPurchaseRequestTable
                    status="6"
                    rawmaterialpurchaserequests={
                      this.state.rawmaterialpurchaserequests
                    }
                    rawmaterialcategory={this.state.rawmaterialcategory}
                    rawmaterialsuppliers={this.state.rawmaterialsuppliers}
                    rawmaterialwarehouse={this.state.rawmaterialwarehouse}
                    prods={this.state.prods}
                    OnDeleted={this.OnDeleted}
                    onHide={this.addModalClose}
                  ></RawMaterialPurchaseRequestTable>
                </>
              ) : (
                <></>
              )}
            </Tab>
          </Tabs>
        </div>
      </>
    );
  }
}

export class RawMaterialPurchaseRequestTable extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      itemsByPR: {}, // { [prId]: [items] }
      loadingByPR: {}, // { [prId]: bool }
      errorByPR: {}, // { [prId]: string }
      totalsByPR: {}, // { [prId]: { totQty, totWeight, totAmount } }
      totalsLoadingByPR: {}, // { [prId]: bool }
      editModalShow: false,
      editPR: null,
    };
  }

  /* ---------------- helpers ---------------- */

  getSupplierNameFromProps = (id) => {
    const sup = (this.props.rawmaterialsuppliers || []).find(
      (s) => s.id === id
    );
    return sup ? sup.name : "";
  };

  getWarehouseNameFromProps = (id) => {
    const wh = (this.props.rawmaterialwarehouse || []).find((w) => w.id === id);
    return wh ? wh.name : "";
  };

  getStatusText = (status) =>
    status === 0
      ? "New"
      : status === 1
      ? "Sent to Supplier"
      : status === 2
      ? "Received"
      : status === 3
      ? "Partially Received"
      : status === 4
      ? "Cancelled"
      : status === 5
      ? "Rejected"
      : status === 6
      ? "Completed"
      : "";

  /* ---------------- lifecycle: preload totals ---------------- */

  componentDidMount() {
    this.preloadTotalsForVisibleRows();
  }

  componentDidUpdate(prevProps) {
    // If parent refreshed the PR list or status filter changed, clear caches then preload
    if (
      prevProps.rawmaterialpurchaserequests !==
        this.props.rawmaterialpurchaserequests ||
      prevProps.status !== this.props.status
    ) {
      // Clear cached per-PR data to avoid stale display
      this.setState(
        {
          itemsByPR: {},
          loadingByPR: {},
          errorByPR: {},
          totalsByPR: {},
          totalsLoadingByPR: {},
        },
        () => {
          // Kick off preload for the new visible rows
          this.preloadTotalsForVisibleRows();
        }
      );
    }
  }

  // get filtered rows based on props.status (same as render uses)
  getRowsFromProps = () => {
    return (this.props.rawmaterialpurchaserequests || []).filter(
      (f) => String(f.status) === String(this.props.status)
    );
  };

  // Kick off totals fetch for each visible PR (skip ones already loaded)
  preloadTotalsForVisibleRows = () => {
    const rows = this.getRowsFromProps();
    if (!rows || rows.length === 0) return;
    rows.forEach((pr) => {
      if (!pr || !pr.id) return;
      if (this.state.totalsByPR[pr.id] || this.state.totalsLoadingByPR[pr.id])
        return;
      this.fetchTotalsForPR(pr);
    });
  };

  // Fetch full PR (same endpoint used for items) but only compute totals and cache them.
  fetchTotalsForPR = async (pr) => {
    if (!pr?.id) return;
    const prId = pr.id;
    this.setState((s) => ({
      totalsLoadingByPR: { ...s.totalsLoadingByPR, [prId]: true },
    }));

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API}Rawmaterials/GetRawMaterialsPurchaseRequestById/${prId}`
      );
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();

      const rawItems =
        data?.rawMaterialsPurchaseRequestItems ||
        data?.RawMaterialsPurchaseRequestItems ||
        [];

      // normalize to numbers and compute totals
      let totQty = 0,
        totWeight = 0,
        totAmount = 0;
      const normalizedItems = rawItems.map((it) => {
        const qty = Number(it.qty ?? 0);
        const qtyReceived = Number(it.qtyReceived ?? 0);
        const weight = Number(it.weight ?? 0);
        const purchasePrice = Number(it.purchasePrice ?? 0);

        totQty += qty;
        totWeight += weight;
        totAmount += purchasePrice * qty;

        return {
          ...it,
          qty,
          qtyReceived,
          weight,
          purchasePrice,
        };
      });

      this.setState((s) => ({
        totalsByPR: {
          ...s.totalsByPR,
          [prId]: { totQty, totWeight, totAmount },
        },
        itemsByPR: { ...s.itemsByPR, [prId]: normalizedItems },
        totalsLoadingByPR: { ...s.totalsLoadingByPR, [prId]: false },
      }));
    } catch (err) {
      this.setState((s) => ({
        totalsLoadingByPR: { ...s.totalsLoadingByPR, [prId]: false },
        errorByPR: {
          ...s.errorByPR,
          [prId]: err?.message || "Failed to load totals",
        },
      }));
    }
  };

  /* ---------------- load items lazily (still used on open) ----------------
     When accordion panel opens we fetch that PR by id and normalize numeric fields.
     This will be a no-op if preload already stored itemsByPR[pr.id].
  */
  ensureItemsLoaded = async (pr) => {
    if (!pr?.id) return;
    const prId = pr.id;
    // Already loaded or loading
    if (this.state.itemsByPR[prId] || this.state.loadingByPR[prId]) return;

    this.setState((s) => ({
      loadingByPR: { ...s.loadingByPR, [prId]: true },
      errorByPR: { ...s.errorByPR, [prId]: null },
    }));

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API}Rawmaterials/GetRawMaterialsPurchaseRequestById/${prId}`
      );
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();

      const rawItems =
        data?.rawMaterialsPurchaseRequestItems ||
        data?.RawMaterialsPurchaseRequestItems ||
        [];

      // Normalize numeric fields
      const items = rawItems.map((it) => ({
        ...it,
        qty: Number(it.qty ?? 0),
        qtyReceived: Number(it.qtyReceived ?? 0),
        weight: Number(it.weight ?? 0),
        purchasePrice: Number(it.purchasePrice ?? 0),
      }));

      this.setState((s) => ({
        itemsByPR: { ...s.itemsByPR, [prId]: items },
        loadingByPR: { ...s.loadingByPR, [prId]: false },
      }));
    } catch (err) {
      this.setState((s) => ({
        loadingByPR: { ...s.loadingByPR, [prId]: false },
        errorByPR: {
          ...s.errorByPR,
          [prId]: err?.message || "Failed to load items",
        },
      }));
    }
  };

  /* ---------------- actions ---------------- */

  openEdit = (purchaseRequest, e) => {
    if (e?.stopPropagation) e.stopPropagation();
    this.setState({ editModalShow: true, editPR: purchaseRequest });
  };

  closeEdit = () => {
    this.setState({ editModalShow: false, editPR: null }, () => {
      if (this.props.onHide) this.props.onHide();
    });
  };

  onDelete = async (purchaseRequest, e) => {
    if (e?.stopPropagation) e.stopPropagation();
    if (!purchaseRequest?.id) return;

    const canDelete =
      !(purchaseRequest.status > 0) ||
      this.context.UserRoles.PRODUCTADMIN === this.context.userData.roleId;

    if (!canDelete) {
      Swal.fire(
        "Restricted",
        "You don't have permission to delete this Purchase Request.",
        "warning"
      );
      return;
    }

    const confirm = await Swal.fire({
      title: "Delete Purchase Request?",
      text: "Warning! This action will delete associated details as well. Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete",
    });
    if (!confirm.isConfirmed) return;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API}Rawmaterials/DeleteRawMaterialsPurchaseRequest/${purchaseRequest.id}`,
        { method: "DELETE", headers: { "Content-Type": "application/json" } }
      );
      if (!res.ok) {
        Swal.fire(
          "Not deleted",
          "This PurchaseRequest may be associated with other records. Disassociate first and retry.",
          "error"
        );
        return;
      }
      Swal.fire("Deleted", "Deleted successfully.", "success");
      this.props.OnDeleted && this.props.OnDeleted();
    } catch (err) {
      Swal.fire("Error", "Delete failed: " + err, "error");
    }
  };

  /* ---------------- render helpers ---------------- */

  renderHeaderLine = (pr) => {
    const prId = pr.id;
    const totals = this.state.totalsByPR[prId];
    const totalsLoading = this.state.totalsLoadingByPR[prId];

    const supplier = this.getSupplierNameFromProps(pr.supplierId);
    const wh = this.getWarehouseNameFromProps(pr.warehouseId);
    const statusText = this.getStatusText(pr.status);
    const totQty = totals ? totals.totQty : null;

    return (
      <div className="d-flex flex-wrap w-100 gap-3 align-items-center">
        <div className="fw-semibold">
          {this.context.GetInDateFormat
            ? this.context.GetInDateFormat(new Date(pr.created))
            : new Date(pr.created).toLocaleString()}
        </div>

        <div className="text-muted">PO: {pr.purchaseOrderNo}</div>

        <Badge bg="secondary">{statusText}</Badge>

        <div className="ms-auto d-flex gap-2 align-items-center">
          <small className="text-muted d-none d-md-inline">
            Supplier: <span className="text-dark">{supplier || "-"}</span> • WH:{" "}
            <span className="text-dark">{wh || "-"}</span>
          </small>

          <small className="text-muted d-none d-lg-inline">
            Requested Qty:{" "}
            <span className="text-dark">
              {totalsLoading ? (
                <Spinner animation="border" size="sm" />
              ) : totQty != null ? (
                totQty
              ) : (
                "-"
              )}
            </span>
          </small>

          <ButtonGroup size="sm">
            <OverlayTrigger overlay={<Tooltip>Edit</Tooltip>}>
              <Button
                variant="warning"
                className="mx-2"
                onClick={(e) => this.openEdit(pr, e)}
              >
                Open
              </Button>
            </OverlayTrigger>

            <OverlayTrigger
              overlay={
                <Tooltip>Delete (will remove associated details)</Tooltip>
              }
            >
              <Button
                variant="danger"
                className="rounded-circle"
                disabled={
                  pr.status > 0 &&
                  this.context.UserRoles.PRODUCTADMIN !==
                    this.context.userData.roleId
                }
                onClick={(e) => this.onDelete(pr, e)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  fill="currentColor"
                  className="bi bi-trash"
                  viewBox="0 0 16 16"
                >
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                  <path
                    fillRule="evenodd"
                    d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                  />
                </svg>
              </Button>
            </OverlayTrigger>
          </ButtonGroup>
        </div>

        <div className="w-100 small text-muted">
          CreatedBy: <span className="text-dark">{pr.createdBy || "-"}</span>
        </div>
      </div>
    );
  };

  renderItemsTable = (items = [], prStatus = -1) => {
    if (!items.length) return <div className="text-muted">No items.</div>;

    // Desktop table
    if (window.innerWidth > 900) {
      return (
        <div className="table-responsive">
          <Table hover size="sm" className="mb-2">
            <thead>
              <tr className="text-center">
                <th>#</th>
                <th className="text-start">Item</th>
                <th className="text-center">Requested Qty (A)</th>
                <th className="text-center">Received Qty (B)</th>
                <th className="text-center">Pending(A-B)</th>
                <th>Unit</th>
              </tr>
            </thead>
            <tbody>
              {items.map((it, idx) => {
                const qty = Number(it.qty ?? 0);
                const qtyReceived = Number(it.qtyReceived ?? 0);
                const diff = qty - qtyReceived;
                const diffClass =
                  diff > 0
                    ? "text-danger"
                    : diff < 0
                    ? "text-warning"
                    : "text-success";

                return (
                  <tr key={it.id || idx} className="text-center">
                    <td>{idx + 1}</td>

                    <td className="text-start" style={{ maxWidth: 280 }}>
                      {it.itemName}
                    </td>

                    <td className="text-center">{qty.toLocaleString()}</td>

                    <td className="text-center">
                      {qtyReceived > 0 ? qtyReceived.toLocaleString() : "-"}
                    </td>

                    <td className={`text-center ${diffClass}`}>
                      {diff.toLocaleString()}
                    </td>

                    <td>{it.unit || "-"}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      );
    }

    // Mobile: stacked table (compact)
    return (
      <div style={{ overflowY: "auto", maxHeight: "45vh" }}>
        <Table bordered size="sm" className="mb-0">
          <thead className="bg-secondary text-white text-center">
            <tr>
              <td width="5%"></td>
              <td width="45%" className="text-start">
                Item
              </td>
              <td width="15%">Req (A)</td>
              <td width="15%">Rcvd (B)</td>
              <td width="15%">A - B</td>
            </tr>
          </thead>
          <tbody>
            {items.map((it, idx) => {
              const qty = Number(it.qty ?? 0);
              const qtyReceived = Number(it.qtyReceived ?? 0);
              const diff = qty - qtyReceived;
              const diffClass =
                diff > 0
                  ? "text-danger"
                  : diff < 0
                  ? "text-warning"
                  : "text-success";

              return (
                <tr key={it.id || idx} className="align-middle text-center">
                  <td>{idx + 1}</td>
                  <td className="text-start">{it.itemName}</td>
                  <td>{qty.toLocaleString()}</td>
                  <td>
                    {qtyReceived > 0 ? qtyReceived.toLocaleString() : "-"}
                  </td>
                  <td className={diffClass}>{diff.toLocaleString()}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  };

  /* ---------------- main render ---------------- */

  render() {
    const rows = (this.props.rawmaterialpurchaserequests || [])
      .filter((f) => String(f.status) === String(this.props.status))
      .sort((a, b) => (new Date(a.created) > new Date(b.created) ? 1 : -1));

    return (
      <>
        <Accordion
          alwaysOpen
          onSelect={(eventKey) => {
            // eventKey is prId (string)
            const pr = rows.find((r) => String(r.id) === String(eventKey));
            if (pr) this.ensureItemsLoaded(pr);
          }}
        >
          {rows.map((pr, idx) => {
            const prId = String(pr.id || idx);
            const items = this.state.itemsByPR[pr.id] || [];
            const loading = Boolean(this.state.loadingByPR[pr.id]);
            const err = this.state.errorByPR[pr.id];

            return (
              <Accordion.Item eventKey={prId} key={prId} className="mb-2">
                <Accordion.Header>{this.renderHeaderLine(pr)}</Accordion.Header>
                <Accordion.Body>
                  {loading ? (
                    <div className="small text-muted">Loading items…</div>
                  ) : err ? (
                    <div className="text-danger small">
                      Failed to load items: {err}
                    </div>
                  ) : (
                    this.renderItemsTable(items, pr.status)
                  )}
                </Accordion.Body>
              </Accordion.Item>
            );
          })}
        </Accordion>

        {this.state.editModalShow && (
          <RawMaterialPurchaseRequestAddOrEditModal
            show={true}
            status={this.props.status}
            onHide={this.closeEdit}
            purchaseRequest={this.state.editPR}
            rawmaterialsuppliers={this.props.rawmaterialsuppliers}
            Type="Edit"
            prods={this.props.prods}
            rawmaterialcategory={this.props.rawmaterialcategory}
            rawmaterialwarehouse={this.props.rawmaterialwarehouse}
          />
        )}
      </>
    );
  }
}

/* --------------------------------------------
   Inline row component (desktop table row)
   Responsive-friendly: uses d-none/d-sm classes
   -------------------------------------------- */

export class RawMaterialPurchaseRequestAddOrEditModal extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);

    this.state = {
      purchaseRequest: { id: undefined, status: -1 },
      currentPurchaseRequestStatus: -1,
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
      rawMaterialsPurchaseRequestItems: [],
      showOrderItemModal: false,
      editPurchaseItemRow: 0,
      categoryFilterName: "",
      reload: true,
      rawmaterialsinventoryFiltered: [],

      // New state for Instk Qty sorting & filtering
      stockSort: "none", // 'none' | 'asc' | 'desc'
      stockFilterMin: "",
      stockFilterMax: "",
      showOnlyInStock: false,
      emailSent: false,
    };
  }

  /* ------------------------- Helper functions ------------------------ */
  GetSupplierName = (id) => {
    if (!id && id !== 0) return "";
    const result = this.props.rawmaterialsuppliers.filter(
      (supplier) => supplier.id == id
    );
    if (result && result.length > 0) return result[0].name || "";
    return "";
  };

  GetWarehouseName = (id) => {
    var result = this.props.rawmaterialwarehouse.filter((f) => f.id == id);
    if (result.length > 0) return result[0].name;
    return "";
  };

  GetWarehouseDetails = (id) => {
    var result = this.props.rawmaterialwarehouse.filter((f) => f.id == id);
    if (result.length > 0)
      return (
        result[0].name +
        "," +
        result[0].address +
        "," +
        result[0].city +
        "," +
        result[0].state +
        "," +
        result[0].country +
        ". ContactNo:" +
        result[0].contactNo +
        ". EmailId:" +
        result[0].emailId
      );
    return "";
  };

  SendEmailToSupplier = async (toEmail) => {
    try {
      if (!this.state.purchaseRequest || !this.state.purchaseRequest.id) {
        Swal.fire(
          "Info",
          "Save the Purchase Request first before sending email.",
          "info"
        );
        return;
      }

      const html = this.GetPurchaseRequestHTML();
      const payload = {
        subject: `Purchase Request - ${
          this.state.purchaseRequest.purchaseOrderNo || ""
        }`,
        plainTextContent: `Purchase Request ${
          this.state.purchaseRequest.purchaseOrderNo || ""
        }`,
        htmlContent: html,
        purchaseRequestId: this.state.purchaseRequest.id,
        attachPdf: false,
      };

      this.ShowLoadSpinner();

      const res = await fetch(
        `${
          process.env.REACT_APP_API
        }Consumers/SendEmailToRawmaterialSuppliers/${
          this.context.storeId
        }/${encodeURIComponent(toEmail)}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      this.HideLoadSpinner();

      if (res.ok) {
        Swal.fire("Success", "Email sent to supplier successfully.", "success");
        this.setState({ emailSent: true });
      } else {
        const err = await res.json().catch(() => ({}));
        Swal.fire("Error", err.detail || "Failed to send email", "error");
      }
    } catch (ex) {
      this.HideLoadSpinner();
      Swal.fire("Exception", ex.message, "error");
    }
  };

  /* ------------------------- Print helpers ------------------------ */
  GetPurchaseRequestHTML = () => {
    const pr = this.state.purchaseRequest || {};
    const items = this.state.rawMaterialsPurchaseRequestItems || [];

    let createdStr = "";
    if (pr.created) {
      try {
        const d = new Date(pr.created);
        if (!isNaN(d.getTime())) {
          createdStr =
            this.context && this.context.GetInDateFormat
              ? this.context.GetInDateFormat(d)
              : d.toISOString();
        }
      } catch (e) {
        createdStr = "";
      }
    }

    const supplierName = this.GetSupplierName(pr.supplierId) || "";
    const warehouseDetails = this.GetWarehouseDetails(pr.warehouseId) || "";

    // ✅ Build logo URL safely
    let logoUrl = "";
    try {
      if (
        this.context?.store?.storageBlobUrl &&
        this.context?.store?.storageBlobContainerName &&
        this.context?.store?.storageSasToken
      ) {
        logoUrl =
          this.context.store.storageBlobUrl +
          this.context.store.storageBlobContainerName +
          "/images/" +
          this.context.storeSettings.storeLogoFileName + // ✅ fixed logo file name
          this.context.store.storageSasToken;
      }
    } catch (e) {
      console.warn("Logo URL not available", e);
    }

    // ✅ Start building HTML
    let str = `
  <!doctype html>
  <html>
  <head>
    <meta charset='utf-8'>
    <title>Purchase Order - Indent</title>
    <style>
      body { font-family: Arial, sans-serif; font-size: 12px; }
      h2 { margin: 4px 0; }
      table { width: 100%; border-collapse: collapse; }
      th, td { padding: 6px; border: 1px dashed #000; }
      th { background: #f0f0f0; }
    </style>
  </head>
  <body>
  `;

    // ✅ Logo section
    if (logoUrl) {
      str += `
      <div style="text-align:center; margin-bottom:4px;">
        <img src="${logoUrl}" alt="Logo" style="width:80px;height:auto;border-radius:8px;" />
      </div>
    `;
    }

    // ✅ Title
    str += `
    <div style="width: 100%;text-align: center">
      <h2><u>Purchase Order - Indent</u></h2>
    </div>
    <hr/>
  `;

    // ✅ Header table (PO number + date)
    str += `
    <table style="width:100%">
      <tr>
        <td style="width:50%"><strong>PO Number:</strong> ${
          pr.purchaseOrderNo || ""
        }</td>
        <td style="width:50%"><strong>Date:</strong> ${createdStr || ""}</td>
      </tr>
    </table>

    <table style="width:100%;margin-top:8px">
      <tr>
        <td style="width:50%"><strong>From:</strong> ${warehouseDetails}</td>
        <td style="width:50%"><strong>To Supplier:</strong> ${supplierName}</td>
      </tr>
    </table>
  `;

    // ✅ Notes
    if (pr.description) {
      str += `
      <p style='margin-top:8px'><strong>Notes:</strong> ${pr.description}</p>
    `;
    }

    str += "<hr/>";

    // ✅ Items table
    str += `
    <table style="width:100%;margin-top:8px;border-collapse:collapse;border:1px dashed #000;text-align:left">
      <thead>
        <tr>
          <th>#</th>
          <th style="text-align:left">Item Name</th>
          <th>Required</th>
          <th>Unit</th>
        </tr>
      </thead>
      <tbody>
  `;

    items.forEach((item, i) => {
      str += `
      <tr>
        <td>${i + 1}</td>
        <td style="text-align:left">${item.itemName || ""}</td>
        <td>${item.qty != null ? item.qty : ""}</td>
        <td>${item.unit || ""}</td>
      </tr>
    `;
    });

    str += `
      </tbody>
    </table>
  </body>
  </html>
  `;

    return str;
  };

  PrintMe = () => {
    var printWindow = window.open("", "_blank");
    if (!printWindow) {
      Swal.fire(
        "Popup blocked",
        "Please allow popups for printing or use the Save/Print option.",
        "warning"
      );
      return;
    }
    printWindow.document.write(this.GetPurchaseRequestHTML());
    printWindow.document.close();
    try {
      printWindow.print();
      // close on desktop (optional)
      if (this.getOS() === "Windows") printWindow.close();
    } catch (err) {
      console.warn("Print failed", err);
    }
  };

  onPrintFinished = () => {};

  getOS = () => {
    var uA = navigator.userAgent || navigator.vendor || window.opera;
    if (
      (/iPad|iPhone|iPod/.test(uA) && !window.MSStream) ||
      (uA.includes("Mac") && "ontouchend" in document)
    )
      return "iOS";

    var i,
      os = ["Windows", "Android", "Unix", "Mac", "Linux", "BlackBerry"];
    for (i = 0; i < os.length; i++)
      if (new RegExp(os[i], "i").test(uA)) return os[i];
  };

  /* ------------------------- Search / Category ------------------------ */
  OnCategoryChanged = (e) => {
    this.setState({ reload: false });
    this.setState({ categoryFilterName: e.target.value }, () => {
      this.setState({ reload: true });
    });
  };

  onSearchChange = (query) => {
    this.setState({ reload: false });
    this.setState({ searchquery: query });
    if (!query) {
      this.setState({ rawmaterialsinventoryFiltered: this.props.prods }, () => {
        this.setState({ reload: true });
      });
      return;
    }
    const fuse = new Fuse(this.props.prods, {
      keys: ["name"],
      threshold: 0.6,
      ignoreLocation: true,
      findAllMatches: true,
      includeMatches: true,
      distance: 120,
    });
    const result = fuse.search(query);
    const finalResult = [];
    if (result.length) {
      result.forEach((item) => {
        finalResult.push(item.item);
      });
      this.setState(
        { rawmaterialsinventoryFiltered: finalResult.slice(0, 25) },
        () => {
          this.setState({ reload: true });
        }
      );
    } else {
      this.setState({ rawmaterialsinventoryFiltered: [] });
    }
  };

  /* ------------------------- Message / Spinner ------------------------ */
  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
    this.props.onHide && this.props.onHide();
  };

  ShowMessagBox = (title, message) => {
    this.setState({
      msgboxOpen: true,
      msgboxTitle: title,
      msgboxMessage: message,
    });
  };
  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  /* ------------------------- Backend fetch ------------------------ */
  GetPurchaseRequestById = (Id) => {
    fetch(
      process.env.REACT_APP_API +
        "Rawmaterials/GetRawMaterialsPurchaseRequestById/" +
        Id
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
          // handle as needed
        } else {
          this.setState({
            purchaseRequest: data,
            rawMaterialsPurchaseRequestItems:
              data.rawMaterialsPurchaseRequestItems || [],
            emailSent: data.emailSent || false,
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  /* ------------------------- Save / Update ------------------------ */
  AddOrUpdatePurchaseRequestInDB = (event, print) => {
    event.preventDefault();
    if (
      !this.state.rawMaterialsPurchaseRequestItems ||
      this.state.rawMaterialsPurchaseRequestItems.length === 0
    ) {
      Swal.fire({
        title: "Information!",
        text: "Add required items to the Purchase Order and try again!",
        timer: 3000,
      });
      return;
    }

    this.ShowLoadSpinner();

    if (this.state.purchaseRequest.status == -1) {
      this.state.purchaseRequest.status = 0; //Created
      this.state.purchaseRequest.createdBy = this.context.userData.emailId;
    }

    var tmpPurchaseRequest = { ...this.state.purchaseRequest };
    tmpPurchaseRequest.storeId = this.context.storeId;
    tmpPurchaseRequest.emailSent = this.state.emailSent;
    tmpPurchaseRequest.rawMaterialsPurchaseRequestItems =
      this.state.rawMaterialsPurchaseRequestItems;

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(tmpPurchaseRequest),
    };

    fetch(
      process.env.REACT_APP_API +
        "Rawmaterials/AddOrUpdateRawMaterialsPurchaseReuest/",
      requestOptions
    )
      .then((res) => {
        this.HideLoadSpinner();
        if (res.status == 200) {
          if (print == true) {
            this.PrintMe();
          }
          this.props.onHide && this.props.onHide();
          return;
        }

        Swal.fire({
          title: "Information!",
          text: "This PurchaseRequest already exists. try again!",
          timer: 3000,
        });
      })
      .catch((error) => {
        this.HideLoadSpinner();

        Swal.fire({
          title: "Exception!",
          text: "Received an Exception. Try after sometime !!" + error,
          timer: 3000,
        });
      });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.AddOrUpdatePurchaseRequestInDB(event);
  };

  handleSelectionChange = (e, index) => {
    var name = "fileName";
    const list = [...this.state.rawMaterialsPurchaseRequestItems];
    list[index][name] = e.value;
    this.setState({ rawMaterialsPurchaseRequestItems: list });
  };

  UpdatePurchaseItem = (item, index) => {
    const items = [...this.state.rawMaterialsPurchaseRequestItems];
    items[index] = { ...items[index], ...item };
    this.setState({
      rawMaterialsPurchaseRequestItems: items,
      editModalShow: false,
    });
  };

  AddPurchaseItem = (item) => {
    this.setState(
      (prev) => ({
        rawMaterialsPurchaseRequestItems: [
          ...prev.rawMaterialsPurchaseRequestItems,
          {
            itemName: item.name,
            qty: 1,
            qtyReceived: 0, // <-- initialize
            weight: item.weight,
            unit: item.unit,
            purchasePrice: item.purchasePrice,
            receivedStatus: 0,
          },
        ],
      }),
      () => {
        this.onHideOrderItemModal();
      }
    );
  };

  AddNewPurchaseItem = () => {
    this.setState(
      (prev) => ({
        rawMaterialsPurchaseRequestItems: [
          ...prev.rawMaterialsPurchaseRequestItems,
          {
            itemName: "",
            qty: 1,
            qtyReceived: 0, // <-- initialize
            weight: 1,
            unit: this.context.storeSettings?.defaultUnit || "piece",
            purchasePrice: 0,
            receivedStatus: 0,
          },
        ],
      }),
      () => {
        this.onHideOrderItemModal();
      }
    );
  };

  handleRemoveClick = (indexno) => {
    const list = [...this.state.rawMaterialsPurchaseRequestItems];
    list.splice(indexno, 1);
    this.setState({ rawMaterialsPurchaseRequestItems: list });
  };

  onHideOrderItemModal = () => {
    this.setState({ showOrderItemModal: false, editModalShow: false });
  };

  handleAddItems = (e) => {
    this.setState({ showOrderItemModal: true });
  };

  OnEditButtonClick = (e, i) => {
    this.setState({ editPurchaseItemRow: i }, () => {
      this.setState({ editModalShow: true });
    });
  };

  editModalClose = () => {
    this.setState({ editModalShow: false });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;

    const pr = { ...this.state.purchaseRequest };
    switch (name.trim()) {
      case "supplierId":
        pr.supplierId = value;
        break;
      case "warehouseId":
        pr.warehouseId = value;
        break;
      case "name":
        pr.name = value;
        break;
      case "status":
        pr.status = value;
        break;
      case "description":
        pr.description = value;
        break;
      default:
        pr[name] = value;
    }
    this.setState({ purchaseRequest: pr });
  };

  handleRawMaterialsInputChange = (e, i) => {
    const { name, value } = e.target;
    const items = [...this.state.rawMaterialsPurchaseRequestItems];

    // convert numeric fields to Number, keep empty string as ""
    const numericFields = ["qty", "qtyReceived", "purchasePrice", "weight"];
    const newVal = numericFields.includes(name)
      ? value === ""
        ? ""
        : value
      : value;

    items[i] = { ...items[i], [name]: newVal };
    this.setState({ rawMaterialsPurchaseRequestItems: items });
  };

  GetPricePerKgOfId = (row) => {
    var result = this.props.prods.filter((f) => f.name == row.itemName);
    if (result.length > 0) {
      var price = result[0].purchasePrice / result[0].weight;
      return price;
    } else {
      return 0;
    }
  };

  GetPriceOfIngredient = (row) => {
    var result = this.props.prods.filter((f) => f.name == row.itemName);
    if (result.length > 0) {
      var perKg = this.GetPricePerKgOfId(row);
      var r = perKg * row.weight;
      return r;
    } else return 0;
  };

  GetTotalEstimation = () => {
    return (this.state.rawMaterialsPurchaseRequestItems || []).reduce(
      (a, v) => a + Number(v.purchasePrice || 0) * Number(v.qty || 0),
      0
    );
  };

  /* ------------------------- New: stock sort/filter handlers ------------------------ */
  onStockSortChange = (e) => {
    this.setState({ stockSort: e.target.value });
  };
  onStockFilterMinChange = (e) => {
    this.setState({ stockFilterMin: e.target.value });
  };
  onStockFilterMaxChange = (e) => {
    this.setState({ stockFilterMax: e.target.value });
  };
  onShowOnlyInStockToggle = (e) => {
    this.setState({ showOnlyInStock: e.target.checked });
  };

  componentDidMount() {
    this.setState({ rawmaterialsinventoryFiltered: this.props.prods || [] });

    if (this.props.Type == "Edit" && this.props.purchaseRequest?.id) {
      this.GetPurchaseRequestById(this.props.purchaseRequest.id);
      this.setState({
        currentPurchaseRequestStatus: this.props.purchaseRequest.status,
      });
    }
    // safe focus attempt
    setTimeout(() => {
      const el = document.getElementById("name");
      if (el && typeof el.focus === "function") el.focus();
    }, 300);

    // keep F8 handler if desired
    this._keyHandler = (event) => {
      if (event.key == "F8") {
        this.handleAddItems(event);
      }
    };
    document.addEventListener("keydown", this._keyHandler);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this._keyHandler);
  }

  GetSupplierDetails = (id) => {
    var r = this.props.rawmaterialsuppliers.filter((f) => f.id == id);
    if (r.length > 0) {
      return r[0].name;
    }
    return "";
  };

  componentDidUpdate(prevProps) {
    // If parent switched to Edit with different purchaseRequest, re-fetch
    if (
      this.props.Type === "Edit" &&
      this.props.purchaseRequest &&
      prevProps.purchaseRequest !== this.props.purchaseRequest &&
      this.props.purchaseRequest.id
    ) {
      this.GetPurchaseRequestById(this.props.purchaseRequest.id);
      if (
        this.props.Type === "Edit" &&
        this.props.purchaseRequest &&
        prevProps.purchaseRequest !== this.props.purchaseRequest
      ) {
        this.setState({
          emailSent: this.props.purchaseRequest.emailSent || false,
        });
      }
      this.setState({
        currentPurchaseRequestStatus: this.props.purchaseRequest.status,
      });
    }

    // if inventory props changed, update filtered list
    if (prevProps.prods !== this.props.prods) {
      this.setState({ rawmaterialsinventoryFiltered: this.props.prods || [] });
    }
  }

  render() {
    /* ------------------------- derive inventory list & apply category + stock filters + sort ------------------------ */
    let inventory = this.state.rawmaterialsinventoryFiltered
      ? [...this.state.rawmaterialsinventoryFiltered]
      : [];

    // Category filter (existing logic)
    inventory = inventory.filter((f) => {
      if (
        this.state.categoryFilterName != "" &&
        this.state.categoryFilterName == f.categoryId
      ) {
        return true;
      } else if (this.state.categoryFilterName == "") {
        return true;
      } else {
        return false;
      }
    });

    // Stock filters
    if (this.state.showOnlyInStock) {
      inventory = inventory.filter((p) => Number(p.instock) > 0);
    }
    if (this.state.stockFilterMin !== "") {
      const min = Number(this.state.stockFilterMin);
      if (!Number.isNaN(min))
        inventory = inventory.filter((p) => Number(p.instock) >= min);
    }
    if (this.state.stockFilterMax !== "") {
      const max = Number(this.state.stockFilterMax);
      if (!Number.isNaN(max))
        inventory = inventory.filter((p) => Number(p.instock) <= max);
    }

    // Sorting by instock
    if (this.state.stockSort === "asc") {
      inventory.sort((a, b) => Number(a.instock) - Number(b.instock));
    } else if (this.state.stockSort === "desc") {
      inventory.sort((a, b) => Number(b.instock) - Number(a.instock));
    } else {
      inventory.sort((a, b) =>
        (a.name || "").toUpperCase() > (b.name || "").toUpperCase() ? 1 : -1
      );
    }

    const totalsEst = this.GetTotalEstimation();

    // Responsive modal: fullscreen on small devices
    return (
      <Modal
        {...this.props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        fullscreen="sm-down"
        style={{ fontFamily: "sans-serif", fontSize: "12px" }}
        backdrop="static"
        keyboard={false}
        dialogClassName="purchaserequest-modal"
      >
        {this.state.msgboxOpen && (
          <MessageBox
            open={this.state.msgboxOpen}
            title={this.state.msgboxTitle}
            message={this.state.msgboxMessage}
            callback={this.CloseMessagBoxCallback}
          />
        )}

        {this.state.loadSpinnerOpen && <LoadSpinner open="true" />}

        <Form onSubmit={this.handleSubmit}>
          <Modal.Header closeButton className="bg-warning p-1 m-0">
            <Modal.Title id="contained-modal-title-vcenter">
              {this.props.Type == "Edit"
                ? "Edit Purchase Request"
                : "Add Purchase Request"}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="p-0">
            {/* outer flexible container; on mobile it will stack */}
            <div className="container-fluid p-2">
              <Row className="g-2">
                {/* Inventory panel: stacks full width on xs, 4/12 on md+ */}
                {this.props.status == 0 && (
                  <Col xs={12} md={4}>
                    <div className="bg-light rounded p-2 h-100 d-flex flex-column">
                      <h6 className="mb-2">Current Stocks in Inventory</h6>

                      <Stack direction="horizontal" gap={2} className="mb-2">
                        <FormControl
                          type="search"
                          placeholder="Search"
                          className="me-2"
                          aria-label="Search"
                          onChange={(e) => this.onSearchChange(e.target.value)}
                        />
                        <Button
                          size="sm"
                          onClick={() =>
                            this.setState({
                              rawmaterialsinventoryFiltered:
                                this.props.prods || [],
                            })
                          }
                        >
                          Reset
                        </Button>
                      </Stack>

                      <InputGroup className="mb-2">
                        <InputGroup.Text>Category</InputGroup.Text>
                        <Form.Select
                          value={this.state.categoryFilterName}
                          onChange={this.OnCategoryChanged}
                        >
                          <option value=""></option>
                          {(this.props.rawmaterialcategory || []).map((m) => (
                            <option key={m.id} value={m.id}>
                              {m.name}
                            </option>
                          ))}
                        </Form.Select>
                      </InputGroup>

                      <div className="d-flex gap-1 mb-2">
                        <Form.Select
                          size="sm"
                          value={this.state.stockSort}
                          onChange={this.onStockSortChange}
                        >
                          <option value="none">Sort: Name (A-Z)</option>
                          <option value="asc">Sort: InStk Qty ↑</option>
                          <option value="desc">Sort: InStk Qty ↓</option>
                        </Form.Select>

                        <Form.Control
                          size="sm"
                          type="number"
                          placeholder="Min Qty"
                          value={this.state.stockFilterMin}
                          onChange={this.onStockFilterMinChange}
                        />
                        <Form.Control
                          size="sm"
                          type="number"
                          placeholder="Max Qty"
                          value={this.state.stockFilterMax}
                          onChange={this.onStockFilterMaxChange}
                        />
                        <Form.Check
                          inline
                          size="sm"
                          type="checkbox"
                          label="Only InStock"
                          checked={this.state.showOnlyInStock}
                          onChange={this.onShowOnlyInStockToggle}
                        />
                      </div>

                      {/* inventory list: make scrollable */}
                      <div style={{ overflowY: "auto", maxHeight: "45vh" }}>
                        <Table borderless size="sm" className="mb-0">
                          <thead>
                            <tr>
                              <th className="text-start">Product</th>
                              <th>InStk</th>
                              <th>Unit</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {inventory.map((prod, i) => (
                              <tr key={prod.id || i}>
                                <td
                                  className="text-start"
                                  style={{ minWidth: 120 }}
                                >
                                  {prod.name}
                                </td>
                                <td>{Number(prod.instock || 0)}</td>
                                <td>{prod.unit}</td>
                                <td className="text-end">
                                  {this.state
                                    .rawMaterialsPurchaseRequestItems &&
                                  this.state.rawMaterialsPurchaseRequestItems.filter(
                                    (p) => p.itemName == prod.name
                                  ).length > 0 ? (
                                    <Button
                                      variant="secondary"
                                      size="sm"
                                      disabled
                                    >
                                      ADDED
                                    </Button>
                                  ) : (
                                    <Button
                                      size="sm"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        this.AddPurchaseItem(prod);
                                      }}
                                    >
                                      Add &gt;&gt;
                                    </Button>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </Col>
                )}

                {/* Right side: form and items - takes full width on xs, 8/12 on md+ */}
                <Col xs={12} md={this.props.status == 0 ? 8 : 12}>
                  <div className="bg-white rounded p-2 h-100 d-flex flex-column">
                    <Row className="align-items-center mb-2">
                      <Col>
                        <h5 className="mb-0">RM Purchase [INDENT]</h5>
                      </Col>
                      <Col className="text-end">
                        <Button
                          variant="warning"
                          size="sm"
                          disabled={this.state.purchaseRequest.id == undefined}
                          onClick={() =>
                            this.AddOrUpdatePurchaseRequestInDB(
                              new Event("click"),
                              true
                            )
                          }
                        >
                          <FaRegFilePdf /> &nbsp; PDF/Print{" "}
                          <BsFillPrinterFill />
                        </Button>
                      </Col>
                      <Col>
                        {Number(this.state.purchaseRequest.status) === 0 && (
                          <Button
                            variant={
                              this.state.emailSent ? "outline-success" : "info"
                            }
                            size="sm"
                            className="ms-2"
                            disabled={!this.state.purchaseRequest.supplierId}
                            onClick={() => {
                              const supplier = (
                                this.props.rawmaterialsuppliers || []
                              ).find(
                                (s) =>
                                  s.id == this.state.purchaseRequest.supplierId
                              );
                              const toEmail =
                                supplier?.emailId ||
                                prompt("Enter supplier email:");
                              if (toEmail) this.SendEmailToSupplier(toEmail);
                            }}
                          >
                            {this.state.emailSent
                              ? "Email Sent — Resend?"
                              : "Send Email to Supplier"}
                          </Button>
                        )}
                      </Col>
                    </Row>

                    {/* Header form fields */}
                    <div className="mb-2">
                      <Row className="g-2">
                        {this.state.purchaseRequest.purchaseOrderNo ? (
                          <Col xs={12} md={3}>
                            <FloatingLabel label="PO Number">
                              <Form.Control
                                type="text"
                                id="name"
                                name="purchaseOrderNo"
                                value={
                                  this.state.purchaseRequest.purchaseOrderNo
                                }
                                disabled
                              />
                            </FloatingLabel>
                          </Col>
                        ) : null}

                        <Col xs={12} md={3}>
                          <FloatingLabel label="Supplier *">
                            <Form.Select
                              size="sm"
                              id="name"
                              name="supplierId"
                              value={
                                this.state.purchaseRequest.supplierId || ""
                              }
                              required
                              disabled={this.props.status != 0}
                              onChange={this.handleInputChange}
                            >
                              <option value=""></option>
                              {(this.props.rawmaterialsuppliers || []).map(
                                (supplier) => (
                                  <option key={supplier.id} value={supplier.id}>
                                    {supplier.name}
                                  </option>
                                )
                              )}
                            </Form.Select>
                          </FloatingLabel>
                        </Col>

                        <Col xs={12} md={2}>
                          <FloatingLabel label="Warehouse *">
                            <Form.Select
                              name="warehouseId"
                              value={
                                this.state.purchaseRequest.warehouseId || ""
                              }
                              disabled={this.props.status != 0}
                              onChange={this.handleInputChange}
                            >
                              <option value=""></option>
                              {(this.props.rawmaterialwarehouse || []).map(
                                (m) => (
                                  <option key={m.id} value={m.id}>
                                    {m.name}
                                  </option>
                                )
                              )}
                            </Form.Select>
                          </FloatingLabel>
                        </Col>

                        <Col xs={12} md={2}>
                          <FloatingLabel label="Status *">
                            <Form.Select
                              name="status"
                              value={this.state.purchaseRequest.status}
                              disabled={
                                this.state.purchaseRequest.id == undefined
                              }
                              onChange={this.handleInputChange}
                            >
                              {this.state.currentPurchaseRequestStatus == -1 ? (
                                <option value={0}>New</option>
                              ) : this.state.currentPurchaseRequestStatus ==
                                0 ? (
                                <>
                                  <option value={0}>New</option>
                                  <option value={1}>Sent to Supplier</option>
                                  <option value={4}>Cancelled</option>
                                </>
                              ) : this.state.currentPurchaseRequestStatus ==
                                1 ? (
                                <>
                                  <option value={1}>Sent to Supplier</option>
                                  <option value={2}>Received</option>
                                  <option value={3}>Partially Received</option>
                                  <option value={4}>Cancelled</option>
                                  <option value={5}>Rejected</option>
                                </>
                              ) : this.state.currentPurchaseRequestStatus ==
                                  2 ||
                                this.state.currentPurchaseRequestStatus == 3 ? (
                                <>
                                  <option value={2}>Received</option>
                                  <option value={3}>Partially Received</option>
                                  <option value={6}>Completed</option>
                                </>
                              ) : this.state.currentPurchaseRequestStatus ==
                                4 ? (
                                <option value={4}>Cancelled</option>
                              ) : this.state.currentPurchaseRequestStatus ==
                                5 ? (
                                <option value={5}>Rejected</option>
                              ) : this.state.currentPurchaseRequestStatus ==
                                6 ? (
                                <option value={6}>Completed</option>
                              ) : null}
                            </Form.Select>
                          </FloatingLabel>
                        </Col>

                        <Col xs={12} md={2} className="text-center">
                          {/* Print already shown top-right; kept for large layout parity */}
                        </Col>
                      </Row>

                      <Row className="mt-2">
                        <Col xs={12}>
                          <FloatingLabel label="Details (if any)">
                            <Form.Control
                              type="text"
                              size="sm"
                              id="description"
                              name="description"
                              maxLength="99"
                              value={
                                this.state.purchaseRequest.description || ""
                              }
                              onChange={this.handleInputChange}
                            />
                          </FloatingLabel>
                        </Col>
                      </Row>
                    </div>

                    {/* Add Item action */}
                    <Row className="mb-2">
                      <Col className="text-end">
                        <Button
                          disabled={this.props.status != 0}
                          size="sm"
                          variant="primary"
                          onClick={() => this.AddNewPurchaseItem()}
                        >
                          + Add Item
                        </Button>
                      </Col>
                    </Row>

                    {/* Items table — scrollable if tall */}
                    {window.innerWidth > 900 ? (
                      <>
                        <div style={{ overflowY: "auto", maxHeight: "45vh" }}>
                          <Table bordered size="sm" className="mb-0">
                            <thead className="bg-secondary text-white text-center">
                              <tr>
                                <td></td>
                                <td className="text-start">Item Name*</td>

                                <td>Required Qty(A)</td>
                                <td>Received Qty(B)</td>
                                <td>Pending(A-B)</td>
                                <td>Unit*</td>
                                {/* <td>Last Purchased Price*</td>
                                <td>Est. Tot</td>
                                <td>Status*</td>
                                <td>Remarks</td> */}
                                <td></td>
                              </tr>
                            </thead>
                            <tbody>
                              {(
                                this.state.rawMaterialsPurchaseRequestItems ||
                                []
                              ).map((row, i) => (
                                <tr key={i} className="text-center">
                                  <td>{i + 1}</td>

                                  <td className="text-start">
                                    <Form.Control
                                      type="text"
                                      name="itemName"
                                      value={row.itemName}
                                      disabled={this.props.status != 0}
                                      onChange={(e) =>
                                        this.handleRawMaterialsInputChange(e, i)
                                      }
                                    />
                                  </td>

                                  <td>
                                    <Form.Control
                                      type="decimal"
                                      name="qty"
                                      className="text-center"
                                      value={row.qty}
                                      disabled={this.props.status != 0}
                                      min={0}
                                      onChange={(e) =>
                                        this.handleRawMaterialsInputChange(e, i)
                                      }
                                    />
                                  </td>

                                  <td>
                                    <Form.Control
                                      type="decimal"
                                      name="qtyReceived"
                                      className="text-center"
                                      value={row.qtyReceived ?? 0}
                                      disabled
                                      min={0}
                                      onChange={(e) =>
                                        this.handleRawMaterialsInputChange(e, i)
                                      }
                                    />
                                  </td>

                                  {/* A - B */}
                                  <td className="text-center">
                                    {Number(
                                      (row.qty || 0) - (row.qtyReceived || 0)
                                    ).toLocaleString()}
                                  </td>

                                  <td>
                                    <Form.Select
                                      name="unit"
                                      value={row.unit}
                                      className="text-center"
                                      disabled={this.props.status != 0}
                                      onChange={(e) =>
                                        this.handleRawMaterialsInputChange(e, i)
                                      }
                                    >
                                      <option value=""></option>
                                      <option value="piece">piece</option>
                                      <option value="gram">gram</option>
                                      <option value="kg">kg</option>
                                      <option value="ton">ton</option>
                                      <option value="ml">ml</option>
                                      <option value="liter">liter</option>
                                      <option value="meter">meter</option>
                                    </Form.Select>
                                  </td>
                                  {/* <td>
                                    <Form.Control
                                      type="number"
                                      name="purchasePrice"
                                      value={row.purchasePrice}
                                      disabled={this.props.status != 0}
                                      onChange={(e) =>
                                        this.handleRawMaterialsInputChange(e, i)
                                      }
                                    />
                                  </td>

                                  <td className="text-center">
                                    {Number(
                                      (row.purchasePrice || 0) * (row.qty || 0)
                                    ).toLocaleString(
                                      this.context.storeSettings
                                        ?.defaultLocale || "en-IN",
                                      {
                                        style: "currency",
                                        currency:
                                          this.context.storeSettings
                                            ?.defaultCurrency || "INR",
                                      }
                                    )}
                                  </td>

                                  <td>
                                    <Form.Select
                                      name="receivedStatus"
                                      value={row.receivedStatus}
                                      onChange={(e) =>
                                        this.handleRawMaterialsInputChange(e, i)
                                      }
                                    >
                                      <option value=""></option>
                                      <option value={0}>Required</option>
                                      <option value={1}>Received</option>
                                      <option value={2}>Yet to Receive</option>
                                      <option value={3}>Unavailable</option>
                                    </Form.Select>
                                  </td>

                                  <td>
                                    <Form.Control
                                      type="text"
                                      name="notes"
                                      value={row.notes}
                                      onChange={(e) =>
                                        this.handleRawMaterialsInputChange(e, i)
                                      }
                                    />
                                  </td> */}

                                  <td>
                                    <Button
                                      size="sm"
                                      variant="danger"
                                      onClick={() => this.handleRemoveClick(i)}
                                    >
                                      Delete
                                    </Button>
                                  </td>
                                </tr>
                              ))}

                              {/* Totals row */}
                              {/* <tr className="fw-bold bg-light">
                                <td colSpan={5} className="text-end">
                                  Est. Total:
                                </td>
                                <td colSpan={4} className="text-start">
                                  <span
                                    style={{
                                      color: "#d39e00",
                                      fontWeight: 700,
                                    }}
                                  >
                                    {Number(totalsEst).toLocaleString(
                                      this.context.storeSettings
                                        ?.defaultLocale || "en-IN",
                                      {
                                        style: "currency",
                                        currency:
                                          this.context.storeSettings
                                            ?.defaultCurrency || "INR",
                                      }
                                    )}
                                  </span>
                                </td>
                              </tr> */}
                            </tbody>
                          </Table>
                        </div>
                      </>
                    ) : (
                      <>
                        <div style={{ overflowY: "auto", maxHeight: "45vh" }}>
                          <Table bordered size="sm" className="mb-0">
                            <thead className="bg-secondary text-white text-center">
                              <tr>
                                <td width="5%"></td>
                                <td width="35%" className="text-start">
                                  Item
                                </td>
                                <td width="15%">Req Qty (A)</td>
                                <td width="15%">Rcvd Qty (B)</td>
                                <td width="15%">Pending(A-B)</td>
                                <td width="15%"></td>
                              </tr>
                            </thead>
                            <tbody>
                              {(
                                this.state.rawMaterialsPurchaseRequestItems ||
                                []
                              ).map((row, i) => {
                                const req = Number(row.qty || 0);
                                const rec = Number(row.qtyReceived || 0);
                                const diff = req - rec;
                                const diffClass =
                                  diff > 0
                                    ? "text-danger"
                                    : diff < 0
                                    ? "text-warning"
                                    : "text-success";

                                return (
                                  <tr
                                    key={i}
                                    className="align-middle text-center"
                                  >
                                    <td>{i + 1}</td>

                                    <td className="text-start">
                                      <Form.Control
                                        type="text"
                                        name="itemName"
                                        value={row.itemName}
                                        disabled={this.props.status != 0}
                                        onChange={(e) =>
                                          this.handleRawMaterialsInputChange(
                                            e,
                                            i
                                          )
                                        }
                                      />
                                    </td>

                                    <td>
                                      <Form.Control
                                        type="number"
                                        name="qty"
                                        value={row.qty}
                                        disabled={this.props.status != 0}
                                        min={0}
                                        onChange={(e) =>
                                          this.handleRawMaterialsInputChange(
                                            e,
                                            i
                                          )
                                        }
                                      />
                                    </td>

                                    <td>
                                      <Form.Control
                                        type="number"
                                        name="qtyReceived"
                                        value={row.qtyReceived ?? 0}
                                        // allow editing when purchaseRequest is in receiving related states:
                                        disabled={
                                          ![1, 2, 3].includes(
                                            Number(
                                              this.state.purchaseRequest.status
                                            )
                                          )
                                        }
                                        min={0}
                                        onChange={(e) =>
                                          this.handleRawMaterialsInputChange(
                                            e,
                                            i
                                          )
                                        }
                                      />
                                    </td>

                                    <td className={diffClass}>
                                      {diff.toLocaleString()}
                                    </td>

                                    <td>
                                      <div className="d-flex gap-1 justify-content-center">
                                        <Button
                                          variant="danger"
                                          size="sm"
                                          onClick={() =>
                                            this.handleRemoveClick(i)
                                          }
                                        >
                                          X
                                        </Button>
                                        <Button
                                          size="sm"
                                          variant="success"
                                          title="Mark received = requested"
                                          onClick={() => {
                                            // mark qtyReceived = qty and set receivedStatus = 1 (received)
                                            const items = [
                                              ...this.state
                                                .rawMaterialsPurchaseRequestItems,
                                            ];
                                            items[i] = {
                                              ...items[i],
                                              qtyReceived: Number(
                                                items[i].qty || 0
                                              ),
                                              receivedStatus: 1,
                                            };
                                            this.setState({
                                              rawMaterialsPurchaseRequestItems:
                                                items,
                                            });
                                          }}
                                        >
                                          ✓
                                        </Button>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          </Modal.Body>

          <Modal.Footer className="bg-light">
            <Form.Group>
              <Button variant="primary" size="lg" type="submit">
                Save
              </Button>
            </Form.Group>

            <Button variant="danger" size="lg" onClick={this.props.onHide}>
              Close
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}
